var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#6A0DAD;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M411.5,320.5c-24-24-52.5-41.7-83.6-52.4c33.3-22.9,55.3-61.4,55.3-104.8C383.2,93.1,326.1,36,256,36 S128.8,93.1,128.8,163.2c0,43.4,21.9,81.9,55.3,104.8c-31.1,10.7-59.6,28.4-83.6,52.4C58.9,362,36,417.2,36,476h34.4 c0-102.4,83.3-185.6,185.6-185.6S441.6,373.6,441.6,476H476C476,417.2,453.1,362,411.5,320.5z M256,256 c-51.2,0-92.8-41.6-92.8-92.8s41.6-92.8,92.8-92.8s92.8,41.6,92.8,92.8S307.2,256,256,256z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileActive);
export default __webpack_public_path__ + "static/media/profileActive.0e8d42fea202f88984a7b25ed47435b8.svg";
export { ForwardRef as ReactComponent };